import axios from '@/plugins/axios.js';
import SnackbarService from '@/services/SnackbarService.js';

export default class RetryRequest {
    constructor({ question, message }) {
        this.ids = [];
        this.question = question;
        this.promptMessage = message;
    }

    delay(delayCount) {
        return new Promise(resolve => {
            const timeout = setTimeout(resolve, delayCount);

            this.ids.push(timeout);
        });
    }

    async request({ action, retryCount = 0, retryLimit = 5, delayCount = 5000, lastError = null, prompt = null }) {
        if (retryCount > retryLimit) throw new Error(lastError);

        return action()
            .then(resp => {
                this._success = true;
                return resp;
            })
            .catch(async error => {
                // Check if the error is due to request cancellation
                if (axios.isCancel(error)) {
                    // Don't retry cancelled requests, just throw the error silently
                    throw error;
                }

                let snackbar = null;

                if (retryCount === 2) {
                    snackbar = SnackbarService.open({
                        type: 'is-danger',
                        message: this.promptMessage,
                        position: 'is-top-left',
                        indefinite: true,
                        actionText: 'Refresh',
                        queue: false,
                        onAction() {
                            window.location.reload();
                        },
                    });
                }

                await this.delay(delayCount);

                return this.request({
                    action,
                    retryCount: retryCount + 1,
                    retryLimit,
                    lastError: error,
                    delayCount,
                    prompt: snackbar,
                });
            })
            .finally(() => {
                if (prompt) prompt.close();

                if (this._success) return;

                if (this.ids.length) {
                    this.ids.forEach(id => clearTimeout(id));

                    this.ids = [];
                }
            });
    }
}
